module.exports = __webpack_public_path__ + "media/images/application/template/logos/thawte-logo-b208405b2ddcc0331c78bba63abb4fe4.png";